<template>
    <div>
        <v-toolbar flat dense color="yellow">
            <v-toolbar-title style="display:flex; align-items:center;">
                <h2>{{ formTitle }}</h2>

                <v-btn class="ml-4"
                       dark
                       small
                       rounded
                       color="error"
                       @click="openFileDialog"
                       v-if="!disabled">
                    <v-icon>mdi-plus</v-icon>

                    <!-- File input oculto -->
                    <input type="file"
                           ref="fileInput"
                           multiple
                           :accept="accept"
                           style="display:none"
                           @change="onFileSelected" />
                </v-btn>
            </v-toolbar-title>
        </v-toolbar>

        <v-row>
            <v-col class="d-flex child-flex"
                   cols="2"
                   v-for="(entry, inx) in combinedItems"
                   :key="inx">
                <!-- Si es imagen -->
                <div v-if="hasImage(entry)" class="text-center" @click="handleClick(entry)">
                    <img :src="getThumbnailSrc(imageName(entry), entry.thumbnail)"
                         :alt="imageName(entry)"
                         style="width: 80px; cursor:pointer;" />
                    <p class="text-caption">{{ imageName(entry) }}</p>
                </div>

                <!-- Si no es imagen (doc/pdf/etc) -->
                <div v-else class="text-center" @click="handleClick(entry)">
                    <v-icon large>mdi-file</v-icon>
                    <p class="text-caption">{{ imageName(entry) }}</p>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "gallery",

        props: {
            value: { type: Object, default: () => ({}) }, // {domain, subDomain, folder}
            items: { type: Array, default: () => [] },
            newItems: { type: Array, default: () => [] },
            title: { type: String, default: "" },

            // opcionales
            disabled: { type: Boolean, default: false },
            accept: {
                type: String,
                default:
                    "image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt",
            },
        },

        data() {
            return {
                base64String: null,
                fileImageName: null,
            };
        },

        computed: {
            formTitle() {
                return this.title;
            },

            combinedItems() {
                return [...(this.items || []), ...(this.newItems || [])];
            },
        },

        methods: {
            // clic directo al input
            openFileDialog() {
                if (this.disabled) return;
                if (this.$refs.fileInput) this.$refs.fileInput.click();
            },

            onFileSelected(event) {
                const files = Array.from(event.target.files || []);
                if (!files.length) return;

                const filePromises = files.map((file) => {
                    return new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            resolve({
                                name: file.name,
                                thumbnail: e.target.result, // "data:image/...;base64,..."
                                file,
                                folder: this.value.folder || "fotos",
                                domain: this.value.domain,
                                subDomain: this.value.subDomain,
                                clienteAbrv: this.value.clienteAbrv,
                                codigo: this.value.codigo,
                            });
                        };
                        reader.readAsDataURL(file);
                    });
                });

                Promise.all(filePromises).then((payload) => {
                    this.$emit("file-selected", payload);

                    // limpiar input para poder elegir el mismo archivo otra vez
                    event.target.value = "";
                });
            },

            getThumbnailSrc(filename, thumbnail) {
                if (!thumbnail) return "";

                // si ya viene como data url completo
                if (typeof thumbnail === "string" && thumbnail.startsWith("data:image"))
                    return thumbnail;

                // si viene como base64 puro
                let fileType = "image/png";
                const lower = (filename || "").toLowerCase();
                if (lower.endsWith(".jpg") || lower.endsWith(".jpeg")) fileType = "image/jpeg";
                if (lower.endsWith(".gif")) fileType = "image/gif";
                if (lower.endsWith(".webp")) fileType = "image/webp";

                return `data:${fileType};base64,${thumbnail}`;
            },

            handleClick(entry) {
                // emit consistente (si existe metadata)
                const name = this.imageName(entry);
                this.$emit("image-selected", name);
                // debug opcional
                // console.log("Elemento clickeado:", entry);
            },

            hasImage(entry) {
                // tu data vieja venía como { metadata: { name }, thumbnail }
                return !!(entry && entry.thumbnail && this.isImageFile(this.imageName(entry)));
            },

            isImageFile(name) {
                const lower = (name || "").toLowerCase();
                return (
                    lower.endsWith(".png") ||
                    lower.endsWith(".jpg") ||
                    lower.endsWith(".jpeg") ||
                    lower.endsWith(".gif") ||
                    lower.endsWith(".webp") ||
                    lower.startsWith("data:image")
                );
            },

            imageName(entry) {
                if (entry?.metadata?.name) return entry.metadata.name;
                return entry?.name || entry?.nombre || "";
            },
        },
    };
</script>

<style scoped>
    .child-flex {
        flex-direction: column;
        align-items: center;
    }
</style>
